import classNames from "classnames";
import type { InputHTMLAttributes } from "react";
import PhoneInput from "react-phone-number-input";
import { ErrorWrapper } from "../Error/ErrorWrapper.tsx";
import "./PhoneField.css";

export type PhoneValue = {
  prefix: string | undefined;
  number: string | undefined;
};

export const PhoneField = ({
  value,
  onChange,
  label,
  placeholder,
  onKeyDown,
  errors,
  ...rest
}: {
  value: PhoneValue;
  onChange: (phoneNumber: PhoneValue) => void;
  className?: string;
  inputClassName?: string;
  label?: string;
  placeholder?: string;
  errors?: string[];
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
} & Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "size" | "onChange" | "value" | "onKeyDown"
>) => (
  <ErrorWrapper errors={errors}>
    <div className="flex-col gap-100">
      {label && <div className="body-md-semibold">{label}</div>}
      <div
        className={classNames(
          PhoneInputClassName,
          "w-full group relative rounded-150 flex-row items-center divide-x",
          errors && errors.length > 0 && "outline-error",
        )}
      >
        <PhoneInput
          className="flex-row items-center w-2000 pl-050 bg-input-surface-rest"
          value={value.prefix}
          onChange={(prefix) => {
            onChange({
              prefix,
              number: value.number,
            });
          }}
          international
          withCountryCallingCode
          numberInputProps={{
            className: "bg-input-surface-rest",
          }}
        />
        <div className="flex-fill flex-row items-center px-150 py-[7px]">
          <input
            className="label-md-default bg-input-surface-rest"
            value={value.number}
            onChange={(event) => {
              onChange({
                prefix: value.prefix,
                number: event.target.value,
              });
            }}
            onKeyDown={(event) => {
              event.stopPropagation();
              onKeyDown?.(event);
            }}
            placeholder={placeholder}
            {...rest}
          />
        </div>
      </div>
    </div>
  </ErrorWrapper>
);

export const PhoneInputClassName = classNames(
  "placeholder:text-secondary",
  "hover:enabled:border-transparent focus:enabled:border-input-border-active ",
  "bg-input-surface-rest hover:enabled:bg-input-surface-hover focus:enabled:bg-input-surface-active disabled:bg-input-surface-disabled",
);
